import { Button, Menu, Spin, Tooltip } from 'antd';
import { Typography } from 'antd';
import { message } from 'antd';
import Layout, { Content } from 'antd/lib/layout/layout';
import Sider from 'antd/lib/layout/Sider';
import HeaderCommon from 'components/Header';
import LoadingComponent from 'components/Loading';
import PrivateRoute from 'components/PrivateRoute';
import { AppRoutes } from 'helpers/app.routes';
import { authoritySelector } from 'modules/auth/selectors';
import { tokenSelector } from 'modules/auth/selectors';
import { logout } from 'modules/auth/slice';
import { clearData as cleanCargoTraceSearch } from 'modules/cargo-trace-search/slice';
import { getNoticeSelector } from 'modules/chatroom/selectors';
import { userInfoSelector } from 'modules/common/selectors';
import { cleanStore as cleanCommon } from 'modules/common/slice';
import { getUserInfor } from 'modules/common/slice';
import { isMdkNotificationSelector } from 'modules/notification/selectors';
import { isMdkNotification } from 'modules/notification/slice';
import NotFound from 'pages/notFound';
import React, { Suspense, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router';
import { Switch, useHistory, useLocation, withRouter } from 'react-router-dom';
import x_close from 'resources/images/close.svg';
import x_close_black from 'resources/images/close_black.svg';
import iconLogout from 'resources/images/icon-log-out.svg';
import logo from 'resources/images/logo.png';
import { privateRoutes } from 'Routes';
import { convertAuthorityMenu } from 'utils';
import { useAppDispatch, useAppSelector } from 'utils/customHooks';

import { USER_MANUAL } from '../../../common/constant';

const { Item } = Menu;
const { Title } = Typography;

const LANG_TYPE: { [key: number]: string } = {
  1: 'en',
  2: 'jp',
  3: 'zh',
};

function PrivateLayout() {
  const { t, i18n } = useTranslation();
  const location = useLocation() as any;
  const dispatch = useAppDispatch();
  const authority = useAppSelector(authoritySelector);
  const { pathname } = location;
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleSub, setVisibleSub] = useState(false);
  const [router, setRouter] = useState<any>([]);
  const [trigger, setTrigger] = useState<boolean>(false);
  const [key, setKey] = useState(0);
  const [keySub, setKeySub] = useState(0);
  const token = useAppSelector(tokenSelector);
  const userInfo = useAppSelector(userInfoSelector);
  const noticeRoom = useAppSelector(getNoticeSelector);
  const noticeMdk = useAppSelector(isMdkNotificationSelector);
  const [isNoticeChatroom, setIsNoticeChatroom] = useState(false);
  const [isNoticeMdk, setIsNoticeMdk] = useState(false);

  const goToPage = (path: string) => () => {
    setVisible(false);
    setVisibleSub(false);
    history.push(path);
  };

  const onShowSubMenu = (paramKey: number) => () => {
    if (key === paramKey) {
      setVisible(!visible);
    } else {
      setKey(paramKey);
      setVisible(true);
    }
  };

  const onShowSubMenuSub = (paramKey: number) => () => {
    if (keySub === paramKey) {
      setVisibleSub(!visibleSub);
    } else {
      setKeySub(paramKey);
      setVisibleSub(true);
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    dispatch(cleanCargoTraceSearch());
    dispatch(cleanCommon());
  };

  const onHideSubMenu = () => {
    setVisible(false);
  };

  const onHideSubMenuSub = () => {
    setVisibleSub(false);
  };

  useEffect(() => {
    const routerAuthority = convertAuthorityMenu(privateRoutes(t), authority);
    const router = [
      { ...routerAuthority[0]?.subMenu?.find((sm: any) => sm.inMenu), path: '/', inMenu: false, subMenu: false },
      ...routerAuthority,
    ];
    setRouter(router);

    if (router?.length > 1) {
      setLoading(false);
    }
  }, [authority, trigger]);

  useEffect(() => {
    if (userInfo?.LANG_TYPE) {
      i18n.changeLanguage(LANG_TYPE?.[userInfo.LANG_TYPE] || LANG_TYPE[1]);
      setTrigger((state) => !state);
    }

    // 通知権限がある場合、未読通知を取得する
    const isNoticeInfoAuthority = convertAuthorityMenu(privateRoutes(t), authority)
      .find((auth) => auth?.path === AppRoutes.notification)
      ?.subMenu?.some((subAuth: any) => subAuth?.path === AppRoutes.notificationInformation);
    if (userInfo && isNoticeInfoAuthority) {
      dispatch(
        isMdkNotification({
          KIDOKU_FLG: '0',
          IS_SERACH: '0',
        })
      );
    }
  }, [userInfo]);

  // 通知状況が空でない場合チャット通知ありとして表示
  useEffect(() => {
    if (noticeRoom && noticeRoom.length > 0) {
      setIsNoticeChatroom(true);
    } else {
      setIsNoticeChatroom(false);
    }
  }, [noticeRoom]);

  useEffect(() => {
    setIsNoticeMdk(noticeMdk);
  }, [noticeMdk]);

  useEffect(() => {
    dispatch(getUserInfor());
    if (isDisplayOnSmartPhone()) {
      setCollapsed(true);
      message.error(t('message.common.0024'));
    }
  }, []);

  if (!token) {
    // 明示的にログアウトボタンを押下した場合、ログアウト前のページを保持しない
    // const redirectPath = pathname === '/' ? '/login' : `/login?redirectPath=${encodeURIComponent(pathname+search)}`;
    return <Redirect to={'/login'} />;
  }

  const renderActiveClassForLeftMenu = (path: string): string => {
    if (pathname === '/' && path === AppRoutes.cargoInformationSearch) {
      return 'active';
    }

    if (path !== '/' && pathname?.includes(path)) {
      return 'active';
    }

    return '';
  };

  const downloadUserManual = (userInfo: any) => {
    if (!userInfo.AIT_USER_FLG) return;
    return '/' + USER_MANUAL;
  };

  const setNotificationClassName = (path: string) => {
    switch (path) {
      case AppRoutes.chatroom:
        return isNoticeChatroom ? 'notificate-menu-item' : '';
      case AppRoutes.notification:
        return isNoticeMdk ? 'notificate-menu-item' : '';
      default:
        return '';
    }
  };

  const isCustomsClearancePath = (path: string) => {
    return AppRoutes.customsClearance === path;
  };

  const setSubMenuClassName = (path: string) => {
    const setLangClassName = () => {
      return i18n?.language === LANG_TYPE[2] ? ' width-jp' : '';
    };
    const setBackgroundColor = (path: string) => {
      if ([AppRoutes.submenu, AppRoutes.notification].includes(path)) return ' gray';
      if (isCustomsClearancePath(path)) return ' gleen';
      return '';
    };

    return `submenu${setLangClassName()}${setBackgroundColor(path)}`;
  };

  const isDisplayOnSmartPhone = () => {
    return window.matchMedia && window.matchMedia('(max-device-width: 640px)').matches;
  };

  return (
    <Layout className="layout_private">
      <Spin spinning={loading}>
        <Layout>
          <Sider
            collapsedWidth="0"
            theme={'light'}
            className="sider"
            width={i18n?.language === LANG_TYPE[2] ? 245 : 315}
            breakpoint="lg"
            onBreakpoint={(broken) => {
              setCollapsed(broken);
            }}
            onCollapse={(collapsed) => {
              setCollapsed(collapsed);
            }}
          >
            <img src={logo} alt="logo" className="logo" />
            <Menu theme="light" selectedKeys={[]} mode="inline" inlineCollapsed={collapsed} tabIndex={-1}>
              {router?.map((item: any, index: number) => (
                <div key={index} className={renderActiveClassForLeftMenu(item?.path)}>
                  {!!item.inMenu && (
                    <Tooltip title={item.name}>
                      <Item
                        key={item.path}
                        icon={item.icon}
                        onClick={item?.subMenu ? onShowSubMenu(index) : goToPage(item.path)}
                        className={`${setNotificationClassName(item.path)}`}
                      >
                        {item.name}
                      </Item>
                    </Tooltip>
                  )}
                  {item?.subMenu && visible && key === index && (
                    <div title={item.name} className={setSubMenuClassName(item?.path)}>
                      <img
                        src={isCustomsClearancePath(item?.path) ? x_close_black : x_close}
                        alt="x_close"
                        className="x_close"
                        onClick={onHideSubMenu}
                      />
                      <Title className="submenu__title">{item?.subTitle}</Title>
                      <div className={'submenu__wrap'}>
                        {item.subMenu
                          .filter((item: any) => !!item?.inMenu)
                          .map((subItem: any, indexSub: number) => (
                            <div key={indexSub}>
                              <Tooltip title={subItem.name} key={indexSub}>
                                <Item
                                  key={subItem.path}
                                  onClick={subItem?.subMenu ? onShowSubMenuSub(indexSub) : goToPage(subItem.path)}
                                >
                                  {subItem.name}
                                </Item>
                              </Tooltip>
                              {subItem?.subMenu && visibleSub && keySub === indexSub && (
                                <div title={subItem.name} className={setSubMenuClassName(item?.path)}>
                                  <img
                                    src={isCustomsClearancePath(item?.path) ? x_close_black : x_close}
                                    alt="x_close"
                                    className="x_close"
                                    onClick={onHideSubMenuSub}
                                  />
                                  <Title className="submenu__title">{subItem?.subTitle}</Title>
                                  <div className={'submenu__wrap'}>
                                    {subItem.subMenu
                                      .filter((item: any) => !!item?.inMenu)
                                      .map((subItem: any, index: number) => (
                                        <Tooltip title={subItem.name} key={index}>
                                          <Item key={subItem.path} onClick={goToPage(subItem.path)}>
                                            {subItem.name}
                                          </Item>
                                        </Tooltip>
                                      ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </Menu>
            {!collapsed && (
              <a href={downloadUserManual(userInfo)} target="_blank" className="user_manual" rel="noreferrer">
                {t('common.link_user_manual')}
              </a>
            )}
            {!collapsed && (
              <Button className="btn-logout" onClick={handleLogout} tabIndex={-1}>
                <img src={iconLogout} alt="logout icon" />
                {t('common.btn_logout')}
              </Button>
            )}
          </Sider>
          <Layout
            onClick={() => {
              if (!visible) return;
              setVisible(false);
            }}
          >
            <HeaderCommon />
            <Content className="layout_private--wrapper-content">
              <Suspense fallback={<LoadingComponent />}>
                <Switch>
                  {router?.map((route: any) => {
                    if (route?.subMenu) {
                      return route.subMenu.map((r: any) => {
                        if (r.subMenu) {
                          return r.subMenu.map(
                            (r: any) => r.component && <PrivateRoute key={r.path} component={r.component} {...r} />
                          );
                        }
                        return r.component && <PrivateRoute key={r.path} component={r.component} {...r} />;
                      });
                    }
                    return route.component && <PrivateRoute key={route.path} component={route.component} {...route} />;
                  })}
                  {!loading && <PrivateRoute path="*" component={NotFound} />}
                </Switch>
              </Suspense>
            </Content>
          </Layout>
        </Layout>
      </Spin>
    </Layout>
  );
}

export default React.memo(withRouter(PrivateLayout));
